import { getNormalizedKeyName } from '../../../utils/readXlsxFile.utils';

export const FIELD_MAPPINGS = categories => ({
  account: 'account',
  description: 'description',
  enabledflag: 'enabledFlag',
  pretax: 'preTaxFlag',
  allowaccountbasedadjustments: 'allowAdjustmentsFlag',
  ...categories.reduce((fieldMappings, { categoryName, description }) => {
    fieldMappings[getNormalizedKeyName(description)] = categoryName;
    return fieldMappings;
  }, {}),
  createdby: 'createdBy',
  createdon: 'createdOn',
  updatedby: 'updatedBy',
  updatedon: 'updatedOn',
});

export const GRID_FIELD_MAPPINGS = categories => ({
  period: 'periodName',
  account: 'account',
  description: 'description',
  pretax: 'preTaxFlag',
  enabledflag: 'enabledFlag',
  allowaccountbasedadjustments: 'allowAdjFlag',
  ...categories.reduce((fieldMappings, { categoryName, description }) => {
    fieldMappings[getNormalizedKeyName(description)] = categoryName;
    return fieldMappings;
  }, {}),
});

export const columnHeaders = categories => ([
  'period',
  'account',
  'description',
  'pretax',
  'enabledflag',
  'allowaccountbasedadjustments',
  ...categories.map(({ description }) => getNormalizedKeyName(description)),
]);

export const MIN_COLUMNS_NUMBER = 6;
export const MAX_COLUMNS_NUMBER = categories => MIN_COLUMNS_NUMBER + categories.length;
